import React from 'react';

import capitalizeFirstLetter from 'shared-utils/src/capitalizeFirstLetter';

import AdditionalLocalitiesList from '@components/common/AdditionalLocalitiesList';
import getExpandedText from '@components/searchPage/Search/utils';

export const getMainLocalityText = ({
  mainLoc,
  qExpansion,
  hasChildrenLocality,
  showPreposition = true,
  isRadiusSearch = false,
  isQBLocalitySearch = false,
}) => {
  try {
    const isMetro = mainLoc && mainLoc.level === 118;  
    let preposition = isRadiusSearch ? 'entro' : isMetro ? 'sulla' : 'a';
    if (mainLoc.name === 'Area disegnata' || mainLoc.name === 'Area su mappa') {
      preposition = 'nella tua';
    }

    if (isQBLocalitySearch) {
      preposition = capitalizeFirstLetter(preposition);
    }

    const weight = isQBLocalitySearch ? 'tp-w--m c-txt--f0' : 'tp-w--l c-txt--f0';
    const province = '(prov.)';

    let text = <b className="tp--b c-txt--f0">Scegli dove</b>;

    if (mainLoc) {
      if (mainLoc.radius) {
        text = <><b className={weight}>{mainLoc.radius}</b> da <b className={weight}>{mainLoc.streetName}</b> a <b className={weight}>{mainLoc.city}</b></>;
      } else if (mainLoc.travelTime) {
        const travelModeParts = mainLoc.travelMode.split(' ');
        text = <><b className={weight}>{mainLoc.travelTime}</b> {travelModeParts[0]} <b className={weight}>{travelModeParts[1]}</b> da <b className={weight}>{mainLoc.streetName}</b> a <b className={weight}>{mainLoc.city}</b></>;
      } else {
        text = <><b className={weight}>{`${mainLoc.name}${mainLoc.level === 6 ? ` ${province}` : ''}`}</b>{hasChildrenLocality ? '' : <> {getExpandedText({ size: 'large', qExpansion, withHighlight: !isQBLocalitySearch })}</>}</>;
      }
    }

    return (
      <>
        {showPreposition && <span className="tp-w--s">{preposition}&nbsp;</span>}
        <span className="location">{text}</span>{!showPreposition && hasChildrenLocality ? ',' : ''}&nbsp;
      </>
    );
  } catch (error) {
    return (
      <>
        {showPreposition && <span className="tp-w--s">a&nbsp;</span>}
        <b className="tp--b c-txt--f0">Scegli dove</b>
      </>
    );
  }
};

export const getButtonText = ({
  mainLevel,
  children,
  qExpansion,
  isQBLocalitySearch = false,
}) => {
  const childrenNumber = children.length;
  if (childrenNumber === 0) return null;
  const isMultiple = childrenNumber > 1;
  let expandedText = getExpandedText({ size: mainLevel >= 9 ? 'small' : 'large', qExpansion, withHighlight: !isQBLocalitySearch });
  
  if (typeof expandedText === 'string' && !expandedText.length) {
    expandedText = '';
  } else {    
    expandedText = isMultiple ? <> ({expandedText})</> : expandedText;
  }
  
  const TextTag = isQBLocalitySearch ? 'span' : 'div';
  const weight = isQBLocalitySearch ? 'tp-w--m' : 'tp-w--l';

  if (mainLevel === 6) {
    return isMultiple ? (
      <>
        <TextTag>nei <b className={`${weight} c-txt--f0`}>comuni</b>{expandedText}:</TextTag>
        <AdditionalLocalitiesList additionalLocalities={children} isQBLocalitySearch={isQBLocalitySearch} />
      </>
    ) : <>nel comune <b className={`${weight} c-txt--f0`}>{children[0].name}</b> {expandedText}</>;
  }
  if (mainLevel === 9 || mainLevel === 130) {
    return isMultiple ? (
      <>
        <TextTag>nelle <b className={`${weight} c-txt--f0`}>zone</b>{expandedText}:</TextTag>
        <AdditionalLocalitiesList additionalLocalities={children} isQBLocalitySearch={isQBLocalitySearch} />
      </>
    ) : <>nella zona <b className={`${weight} c-txt--f0`}>{children[0].name}</b> {expandedText}</>;
  }
  if (mainLevel === 118) {
    return isMultiple ? (
      <>
        <TextTag>intorno alle <b className={`${weight} c-txt--f0`}>fermate</b>{expandedText}:</TextTag>
        <AdditionalLocalitiesList additionalLocalities={children} isQBLocalitySearch={isQBLocalitySearch} />
      </>
    ) : <>intorno alla fermata <b className={`${weight} c-txt--f0`}>{children[0].name}</b> {expandedText}</>;
  }
};
